const AUTH_KEY = 'mcn_auth'

export function getAuthState() {
  try {
    const raw = localStorage.getItem(AUTH_KEY)
    return raw ? JSON.parse(raw) : null
  } catch { return null }
}

export function saveAuthState(state) {
  localStorage.setItem(AUTH_KEY, JSON.stringify(state))
}

export function clearAuthState() {
  localStorage.removeItem(AUTH_KEY)
}

export function isLoggedIn() {
  const s = getAuthState()
  return !!(s && s.token)
}

export function isSetupComplete() {
  const s = getAuthState()
  return !!(s && s.setupStep >= 4)
}

export function getSetupStep() {
  const s = getAuthState()
  return s ? (s.setupStep || 0) : 0
}

// 模拟手机号格式验证
export function validatePhone(phone) {
  return /^1[3-9]\d{9}$/.test(phone.trim())
}

// 模拟已注册账号（demo用）
const DEMO_ACCOUNTS = { '13800138000': '123456', '18888888888': 'password' }

export function mockLogin(phone, password) {
  if (!validatePhone(phone)) return { ok: false, msg: '请输入正确的手机号' }
  if (!password) return { ok: false, msg: '请输入密码' }
  if (DEMO_ACCOUNTS[phone] && DEMO_ACCOUNTS[phone] !== password) return { ok: false, msg: '密码错误' }
  return { ok: true, token: 'token_' + phone }
}

export function mockRegister(phone, password) {
  if (!validatePhone(phone)) return { ok: false, msg: '请输入正确的手机号' }
  if (password.length < 6) return { ok: false, msg: '密码至少 6 位' }
  return { ok: true, token: 'token_' + phone }
}
